export default "__VITE_ASSET__CLitW2gM__"